import { Link } from 'react-router-dom';
import { useTravelText } from '../../app/TravelLocaleContext';
import { normalizeStoryCardCount } from './discoverModel';

const K = 'travel.discover.story';
const PUBLICATION_ID = /^[1-9]\d*$/;

/**
 * 探索卡片的故事訊號：「含旅遊故事・N 則」文字標示＋次要連結「閱讀故事」（?view=story）。
 * 卡數不是安全範圍內的正整數、或 publication ID 不合法時不渲染；ID 一律以字串組連結，不轉 Number。
 * 卡片主要連結仍由卡片本身負責（行程總覽），本元件不包住任何其他連結。
 */
export default function JourneyStoryEntry({ publicationId, title, storyCardCount, compact = false }) {
  const { t, tf, tp } = useTravelText();
  const count = normalizeStoryCardCount(storyCardCount);
  const id = publicationId == null ? '' : String(publicationId);
  if (count == null || !PUBLICATION_ID.test(id)) return null;
  const label = String(title || '').trim();
  if (compact) return (
    <Link to={`/public/journeys/${id}?view=story`} className="journey-story-entry__link"
      aria-label={label ? tf(`${K}.readLabel`, { title: label }) : undefined}
      data-testid="journey-story-entry-link">
      {t('travel.journeyDiscovery.readStory')}
    </Link>
  );

  return (
    <div className="journey-story-entry" data-testid="journey-story-entry">
      <span className="journey-story-entry__badge" data-testid="journey-story-entry-badge">
        {tp(`${K}.count`, count)}
      </span>
      <Link
        to={`/public/journeys/${id}?view=story`}
        className="journey-story-entry__link"
        aria-label={label ? tf(`${K}.readLabel`, { title: label }) : undefined}
        data-testid="journey-story-entry-link"
      >
        {t(`${K}.read`)}
      </Link>
    </div>
  );
}
